import React, { useEffect } from 'react';
import GnbTabs from '@routes/Common/CommonLayout/GnbTabs';
import CommonLayout from '@routes/Common/CommonLayout';
import CompanyInfoView from './CompanyInfoView';
import BottomNav from '@routes/Common/BottomNav';
import FooterContainer from '@components/Footer';
import useQueryString from '@hooks/useQueryString';
import useClient from '@hooks/useClient';
import { useHistory } from 'react-router-dom';

const CompanyInfoPresenter: React.FunctionComponent = () => {
  const {
    query: { partnerId }
  } = useQueryString<{ partnerId?: string }>();
  const history = useHistory();

  useEffect(() => {
    if (!partnerId) {
      history.replace('/companyInfo/notfound');
    }
  }, [partnerId, history]);

  const {
    clientState: { accessToken }
  } = useClient();

  const isAuth = !!accessToken;

  if (!partnerId) return null;

  return (
    <CommonLayout
      gnbTabs={isAuth ? <GnbTabs /> : <></>}
      bottomNav={isAuth && <BottomNav />}
    >
      <CompanyInfoView partnerId={partnerId} isAuth={isAuth} />
      <FooterContainer />
    </CommonLayout>
  );
};

export default CompanyInfoPresenter;
